/** Accepts only Mapbox public tokens, which are intended for browser map requests. */
export function parseMapboxPublicToken(value: unknown): string | null {
  return typeof value === "string" && /^pk\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value.trim())
    ? value.trim() : null;
}
